import { call, select } from 'redux-saga/effects';
import { callWithAuth } from '../../sagaApiHelper';
import { getWabaIdsApi } from '../../../api/apiLists/getWabaIdsApi';
import { getWabaIdsFromStorage, saveWabaIdsToStorage } from '../../../utils/apiCacheHelper';

export function* getOrFetchWabaId() {
  const cachedWabaId = sessionStorage.getItem('waba_id');
  if (cachedWabaId) {
    return cachedWabaId;
  }

  try {
    const companyInfo = yield select(state => state.companyInfo?.info || {});
    const companyId = yield select(state => state.auth?.user?.companyId || companyInfo?.companyId || companyInfo?.id || '');

    if (!companyId) {
      return null;
    }

    const cachedAccounts = getWabaIdsFromStorage(companyId);
    if (cachedAccounts && cachedAccounts.length > 0 && cachedAccounts[0]?.wabaId) {
      const wabaId = cachedAccounts[0].wabaId;
      sessionStorage.setItem('waba_id', wabaId);
      return wabaId;
    }

    const channelReq = {
      operation: 'GETWABAIDS',
      payload: { companyId }
    };

    const channelRes = yield call(callWithAuth, getWabaIdsApi, channelReq);
    if (channelRes?.status === true) {
      const data = channelRes.data || channelRes || {};
      if (Array.isArray(data?.result?.data) && data.result.data.length > 0 && data.result.data[0]?.wabaId) {
        const wabaId = data.result.data[0].wabaId;
        const accounts = data.result.data;
        saveWabaIdsToStorage(accounts, companyId);
        sessionStorage.setItem('waba_id', wabaId);
        return wabaId;
      }
    }
  } catch (error) {
    console.error('Error fetching WABA ID:', error);
  }

  return null;
}
